import { render, staticRenderFns } from "./PublicFooter.htm?vue&type=template&id=68400a22&scoped=true&"
import script from "./PublicFooter.ts?vue&type=script&lang=js&"
export * from "./PublicFooter.ts?vue&type=script&lang=js&"
import style0 from "./PublicFooter.scss?vue&type=style&index=0&id=68400a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68400a22",
  null
  
)

export default component.exports